"use client";
//#region src/popover/__utils.ts
function getBasePlacement(placement) {
	return placement.split("-")[0];
}
//#endregion
export { getBasePlacement as t };

//# sourceMappingURL=B3k5_R1L.js.map